import type { StyleLayer } from './utils/types'

export const layers_parkingLars_parkinglines_completeness: StyleLayer[] = [
  {
    id: 'capacity_status-segment_too_small',
    type: 'line',
    filter: ['match', ['get', 'capacity_status'], ['segment_too_small'], true, false],
    paint: {
      'line-color': 'hsl(4, 59%, 27%)',
      'line-dasharray': [0.5, 0.5],
      'line-opacity': [
        'match',
        ['get', 'highway'],
        ['secondary', 'construction', 'pedestrian'],
        0.25,
        1,
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
    },
  },
  {
    id: 'capacity_status-no_parking',
    type: 'line',
    filter: ['match', ['get', 'capacity_status'], ['no_parking'], true, false],
    paint: {
      'line-color': 'hsl(273, 100%, 43%)',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
    },
  },
  {
    id: 'capacity_status-data_missing',
    type: 'line',
    filter: ['match', ['get', 'capacity_status'], ['data_missing'], true, false],
    paint: {
      'line-color': 'hsl(319, 100%, 38%)',
      'line-opacity': [
        'match',
        ['get', 'highway'],
        ['secondary', 'construction', 'pedestrian'],
        0.25,
        1,
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
    },
  },
]
